import { wrapFunction } from '../utils';

export const CAPITALCASE = (s: string): string => {
  return s
    .split(' ')
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
};

export default wrapFunction(CAPITALCASE, {
  name: 'CAPITALCASE',
  nargs: 1,
  types: ['string'],
});
